import { Subject } from 'rxjs';

import { Component, OnDestroy } from '@angular/core';

import { SnTableBaseComponent } from '@lib/core';

import { FsPolicyGroup } from '../../models';

@Component({
  selector: 'fs-policy-groups-table',
  templateUrl: './policy-groups-table.component.html',
  styleUrls: ['./policy-groups-table.component.scss'],
})
export class FsPolicyGroupsTableComponent
  extends SnTableBaseComponent<FsPolicyGroup>
  implements OnDestroy
{
  private readonly _destroy$ = new Subject();

  constructor() {
    super();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackBy(index: number, item: FsPolicyGroup): any {
    return item.id;
  }
}
